<template>
  <div class="main">
    <Header
      :show="true"
      title="我的"
      left=""
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div>
      <van-cell
        center
        is-link
      >
        <template #icon>
          <van-icon
            :name="imageSrc.avatar"
            size="20vw"
            style="margin: 4vw 0"
          />
        </template>
        <template #title>
          {{ listQuery.name }}
        </template>
        <template #label>
          用户名：{{ listQuery.username }}
        </template>
        <template #default>
          <van-icon
            :name="imageSrc.user"
            size="5vw"
            style="padding-top: 1.2vh"
          />
        </template>
      </van-cell>
      <van-cell
        title="我的项目"
        center
        is-link
        @click="handleClickProject"
      >
        <template #icon>
          <van-icon
            :name="imageSrc.project"
            color="#BBB"
            size="5vw"
            style="margin-right: 1.5vw"
          />
        </template>
      </van-cell>
      <van-cell
        title="修改密码"
        center
        is-link
        @click="handleClickPassword"
      >
        <template #icon>
          <van-icon
            :name="imageSrc.password"
            color="#BBB"
            size="5vw"
            style="margin-right: 1.5vw"
          />
        </template>
      </van-cell>
      <van-cell
        title="操作手册"
        is-link
        @click="handleClickManual"
      >
        <template #icon>
          <van-icon
            :name="imageSrc.manual"
            color="#BBB"
            size="5vw"
            style="margin-right: 1.5vw"
          />
        </template>
      </van-cell>
      <!-- <van-cell title="运行日志" icon="file-text" color="#BBB" is-link @click="handleClickRunLog" /> -->
      <van-cell
        title="关于我们"
        is-link
        @click="handleClickAboutUs"
      >
        <template #icon>
          <van-icon
            :name="imageSrc.aboutus"
            color="#BBB"
            size="5vw"
            style="margin-right: 1.5vw"
          />
        </template>
      </van-cell>
      <van-cell
        title="退出登录"
        is-link
        @click="handleClickExit"
      >
        <template #icon>
          <van-icon
            :name="imageSrc.logout"
            color="#BBB"
            size="5vw"
            style="margin-right: 1.5vw"
          />
        </template>
      </van-cell>
    </div>
    <Footer value="user" />
  </div>
</template>

<script>
import * as imageConversion from "image-conversion";
import { mapGetters } from "vuex";
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import { info } from "@/config/config.json";
import { getSelf, logout } from "@/api/user.js";
import { createWhiteOne, deleteWhiteOne } from "@/api/staff.js";

export default {
  name: "User",
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    return {
      loading: false,
      listQuery: {
        serial: null,
        username: "",
        name: "永固万年青",
        phone: "",
        discribe: "心怀信仰，沐浴阳光",
        image: [require("@/assets/user/header.jpg")],
        avatar: require("@/assets/user/header.jpg"),
        gate: 3,
        file: null,
        reason: "员工绿色通道",
        startDate: new Date().getTime(),
        endDate: new Date().getTime(),
        validEnable: 1,
      },
      fullWidth: document.documentElement.clientWidth,
      fullHeight: document.documentElement.clientHeight,
      baseUrl: "",
      manualUrl: info["manual-address"],
    };
  },
  computed: {
    ...mapGetters({
      userid: "user/userid",
      username: "user/username",
      name: "user/name",
      phone: "user/phone",
      discribe: "user/discribe",
      avatar: "user/avatar",
    }),
  },
  watch: {},
  beforeCreate() {},
  created() {
    const url = window.location.href;
    this.baseUrl = ''
    const avatar = this.baseUrl + this.avatar;
    console.log(avatar);
    this.listQuery.image = [];
    if (this.avatar !== "" && this.avatar !== null) {
      this.listQuery.image.push(avatar);
      this.listQuery.avatar = avatar;
    }
    const userid = this.userid;
    if (userid !== null) {
      this.listQuery.serial = userid;
    }
    const username = this.username;
    if (username !== "" && username !== null) {
      this.listQuery.username = username;
    }
    const name = this.name;
    if (name !== "" && name !== null) {
      this.listQuery.name = name;
    }
    const phone = this.phone;
    if (phone !== "" && phone !== null) {
      this.listQuery.phone = phone;
    }
    const discribe = this.discribe;
    if (discribe !== "" && discribe !== null) {
      this.listQuery.discribe = discribe;
    }
    console.log(this.listQuery);
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    checkPermission,
    handleClickLeft() {
      // this.$router.go(-1)
      console.log("dashboard-left");
    },
    handleClickRight() {
      console.log("dashboard-right");
    },
    handleClickProject() {
      window.location.href = "http://www.qtsea.com/ataw/#/wxwork/project";
    },
    beforeRead(file) {
      const allowType = ["image/png", "image/jpeg"];
      if (!allowType.includes(file.type)) {
        this.$toast("请上传jpg/png格式图片");
        return false;
      }
      return true;
    },
    afterRead(file) {
      console.log("怎么了这是？");
      return new Promise((resolve, reject) => {
        let isLt2M = file.file.size / 1024 / 1024 < 0.2; // 判定图片大小是否小于4MB
        if (isLt2M) {
          this.listQuery.file = file.file;
          console.log("大小正合适");
          this.handleClickUpdateAvatar();
          resolve(file);
        } else {
          const scale = parseFloat(
            1 / (file.file.size / 1024 / 1024 / 0.2)
          ).toFixed(2);
          imageConversion
            .compressAccurately(file.file, {
              size: 180,
              // scale: scale,
              width: 640,
            })
            .then((res) => {
              this.listQuery.file = res;
              console.log("压缩比较好");
              this.handleClickUpdateAvatar();
              resolve(res);
            });
        }
      });
    },
    handleClickUpdateAvatar() {
      this.handleClickCreateAvatar();
    },
    handleClickCreateAvatar() {
      let data = new FormData();
      data.append("name", this.listQuery.name);
      data.append("phone", this.listQuery.phone);
      data.append("gate", this.listQuery.gate);
      data.append("image", this.listQuery.file);
      data.append("reason", this.listQuery.reason);
      data.append("startDate", this.listQuery.startDate);
      data.append("endDate", this.listQuery.endDate);
      data.append("validEnable", this.listQuery.validEnable);
      this.loading = true;
      createWhiteOne(data, this.listQuery.serial)
        .then((response) => {
          const { data } = response;
          showPhoneAlarm(
            true,
            "toast",
            null,
            2000,
            data.code,
            "添加人脸信息",
            data.message
          );
          this.loading = false;
        })
        .catch(function (error) {
          this.loading = false;
          console.error(error);
        });
    },
    handleClickPassword() {
      this.$router.push({
        path: "/user/password",
        query: {},
      });
    },
    handleClickManual() {
      window.open(this.manualUrl, "_blank");
    },
    handleClickRunLog() {
      this.$router.push({
        path: "/user/log",
        query: {},
      });
    },
    handleClickAboutUs() {
      window.location.href = window.open(info["official-site"], "_blank");
    },
    handleClickExit() {
      this.$store.dispatch("user/logout").then((response) => {
        const { data } = response;
        if (
          showPhoneAlarm(
            true,
            "toast",
            null,
            2000,
            data.code,
            "退出登录",
            data.message
          )
        ) {
          // console.log('退出登录成功')
        }
        this.$router
          .replace({
            path: "/login",
            query: {},
          })
          .catch(() => {});
      });
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
.van-cell {
  padding: 2.4vw 3vw;
}
::v-deep .van-cell__label {
  width: 60vw;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
